import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { Navbar, Sidebar, Spacer } from '../../components';
import { Chrono } from "react-chrono";

function RoadMap() {
  const [closeSide, setCloseSide] = useState(false);
  const [modeRoad, setModeRoad] = useState('HORIZONTAL')
  useEffect(() => {
    !window.matchMedia("(min-width: 768px)").matches ? setModeRoad('VERTICAL') : setModeRoad('HORIZONTAL')
  }, [modeRoad])
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  const items = [
    {
      title: "Process",
      cardTitle: "Prosses",
      cardSubtitle: "Start: Jan 2021",
      cardDetailedText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, vitae.",
    },
    {
      title: "Process",
      cardTitle: "Prosses",
      cardSubtitle: "Start: March 2021",
      cardDetailedText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, vitae.",
    },
    {
      title: "Milestone",
      cardTitle: "Milestone",
      cardSubtitle: "Start: March 2021",
      cardDetailedText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, vitae.",
    },
    {
      title: "Milestone",
      cardTitle: "Milestone",
      cardSubtitle: "Start: April 2021",
      cardDetailedText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, vitae.",
    },
    {
      title: "Beta Testing",
      cardTitle: "Testing",
      cardSubtitle: "Start: August 2021",
      cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
    },
    {
      title: "Launch",
      cardTitle: "Production",
      cardSubtitle: "December 2022",
      cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
    },
  ]



  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            <div className="cardContainer">
              <div className="cardUtil">
                <span className="titleCard d-block">Roadmap</span>
              </div>
              <Spacer h={50} />
              <div style={{ width: "100%" }}>
                <Chrono
                useReadMore={false}
                  items={items}
                  slideShow
                  mode={modeRoad}
                  scrollable={{ scrollbar: true }}
                  theme={{
                    primary: "#6418C3",
                    secondary: "#F56B3F",
                    cardBgColor: "#FFF",
                    cardForeColor: "#FEF1EC",
                    titleColor: "#FFF"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default RoadMap
